import { Flash, MessageBubble } from "components/icons/generated";
import { IconComponent } from "types/Icon";

import { ChatMode } from "../types";

export const CHAT_MODES: Record<
  ChatMode,
  {
    label: string;
    tooltip: string;
    icon: IconComponent;
  }
> = {
  [ChatMode.ASK]: {
    label: "Chat",
    tooltip: "The AI can answer questions and troubleshoot issues.",
    icon: MessageBubble,
  },
  [ChatMode.BUILD]: {
    label: "Build",
    tooltip: "The AI can answer questions and execute actions on your behalf.",
    icon: Flash,
  },
};
